import _defineProperty from "@babel/runtime/helpers/defineProperty";
import AkButton from '@atlaskit/button/standard-button';
import { ButtonClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import React, { PureComponent } from 'react';
export default class SecondaryCTA extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "render", () => /*#__PURE__*/React.createElement(AkButton, {
      isDisabled: this.props.isDisabled,
      appearance: "subtle-link",
      onClick: this.props.onClick
    }, this.props.children));
  }
}
_defineProperty(SecondaryCTA, "defaultProps", {
  isDisabled: false
});
export class SecondaryCTAWithAnalyticsComponent extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", () => {
      this.props.fireAnalyticsEvent({
        eventType: ButtonClickedEvent,
        actionSubjectId: this.props.actionSubjectId
      });
      this.props.onClick();
    });
    _defineProperty(this, "render", () => /*#__PURE__*/React.createElement(SecondaryCTA, {
      isDisabled: this.props.isDisabled,
      onClick: this.onClick
    }, this.props.children));
  }
}
export const SecondaryCTAWithAnalytics = withAnalytics(SecondaryCTAWithAnalyticsComponent);